import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M23.296 16.66c-.45.59-1.55 1.011-1.55 1.011l-8.189 3.066v-2.261l6.026-2.238c.684-.255.789-.616.233-.805-.555-.19-1.56-.136-2.244.12l-4.015 1.474v-2.346l.232-.081s1.16-.428 2.791-.617c1.632-.187 3.63.026 5.198.645 1.767.582 1.966 1.44 1.518 2.031Zm-8.96-3.85V7.03c0-.68-.12-1.305-.73-1.482-.469-.156-.76.297-.76.975V21L9.1 19.76V2.5c1.593.308 3.914 1.037 5.161 1.475 3.173 1.135 4.249 2.548 4.249 5.731 0 3.103-1.838 4.279-4.174 3.104Zm-12.11 5.43C.412 17.707.11 16.598.937 15.959c.764-.59 2.064-1.035 2.064-1.035l5.372-1.99v2.269l-3.866 1.442c-.683.255-.788.616-.233.806.556.19 1.56.135 2.245-.12l1.854-.702v2.03c-.118.022-.249.044-.37.065-1.855.316-3.83.184-5.777-.484Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
